import React, {useEffect, useState} from 'react'
import {Rect, Text, Transformer} from "react-konva";
import * as _ from "lodash";
import {BLOCK_SNAP_SIZE} from "../../../constants/design.constant";

const RectangleShape = ({
                            shapeProps,
                            onChange,
                            handleGuidelineDragEnd,
                            handleGuidelineDragMove
                        }) => {
    const shapeRef = React.useRef();

    const handleDragEnd = (event) => {
        const node = shapeRef.current || undefined;

        const currentTextRef = event.target;
        currentTextRef.position({
            x: Math.round(currentTextRef.x() / BLOCK_SNAP_SIZE) * BLOCK_SNAP_SIZE,
            y: Math.round(currentTextRef.y() / BLOCK_SNAP_SIZE) * BLOCK_SNAP_SIZE
        });

        onChange({
            ...shapeProps,
            x: node.x(),
            y: node.y(),
            scaleX: node.scaleX(),
            scaleY: node.scaleY(),
            totalWidth: node.width(),
            totalHeight: node.height()
        });
    }

    const handleTransformEnd = (event) => {
        const node = shapeRef.current || undefined;

        const scaleX = node.scaleX();
        const scaleY = node.scaleY();
        node.scaleX(1);
        node.scaleY(1);

        const width = _.parseInt(String(Math.max(5, (node.width() * scaleX) + 10)));
        const height = _.parseInt(String(Math.max(5, (node.height() * scaleY) + 10)));

        onChange({
            ...shapeProps,
            x: node.x(),
            y: node.y(),
            scaleX: node.scaleX(),
            scaleY: node.scaleY(),
            totalWidth: width,
            totalHeight: height,
            width: width,
            height: height,
            rotation: node.rotation(),
        });
    }

    return (
        <>

            <Rect
                ref={shapeRef}
                {...shapeProps}
                name={'object'}
                draggable
                onTransformEnd={handleTransformEnd}
                onDragMove={(e) => {
                    handleDragEnd(e);
                    handleGuidelineDragMove(e);
                }}
                onDragEnd={(e) => {
                    handleDragEnd(e);
                    handleGuidelineDragEnd(e);
                }}
            />

        </>
    )
}

export default RectangleShape
